export default __webpack_public_path__ + "static/circle_about_me-7c3dec9d6e6f3382e2ce44aaa2526972.png";